import { imgUrl } from "../lib/api";

export const artAlt = (art) =>
  `${art?.title ? `${art.title} — ` : ""}Artwork by Kenny DePrince — ARTILLERY KDP`;

export const ArtImage = ({ art, size = "md", className = "", alt, sizes = "100vw", eager = false, testId }) => {
  if (!art?.images) {
    return (
      <div className={`bg-charcoal flex items-center justify-center ${className}`} data-testid={testId}>
        <span className="text-[10px] tracking-[0.3em] text-smoke">IMAGE COMING SOON</span>
      </div>
    );
  }
  return (
    <img
      src={imgUrl(art.images[size] || art.images.md)}
      srcSet={`${imgUrl(art.images.sm)} 640w, ${imgUrl(art.images.md)} 1024w, ${imgUrl(art.images.lg)} 1600w`}
      sizes={sizes}
      alt={alt || artAlt(art)}
      loading={eager ? "eager" : "lazy"}
      draggable={false}
      onContextMenu={(e) => e.preventDefault()}
      className={`artwork-view ${className}`}
      data-testid={testId}
    />
  );
};
